import _ from 'underscore';

function without(plugin, dependency, buildReplacement) {
  return definePlugin => plugin((name, dependencies, callback) => {
    const index = _.indexOf(dependencies, dependency);
    const newDeps = _.without(dependencies, dependency);
    return definePlugin(
      name,
      newDeps,
      (...args) => {
        const objDeps = _.object(newDeps, args);
        args.splice(index, 0, buildReplacement(objDeps));
        return callback(...args);
      }
    );
  });
}

export function withoutFilterState(plugin) {
  return plugin;
}

export function withoutSegment(plugin) {
  return without(plugin, 'segment', () => ({
    getAvailableSegmentationTypes: () => [],
    getSegmentType: () => null,
    validateSegmentType: () => true,
  }));
}
